
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impfstelle from '@/types/Impfstelle';
    import { Validatable, VForm } from '@/types/Components';
    import { LoadPersonenPayload } from '@/store/personen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('authentication', ['impfstelle', 'loaders']),
            ...mapState('personen', ['personen']),
            ...mapState('personen', { personenLoaders: 'loaders' }),
            ...mapGetters('authentication', ['isAllowed']),
            ...mapState('cards', ['cards']),
            ...mapState('cards', { cardsLoaders: 'loaders' }),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('authentication', ['updateImpfstelleDetail']),
            ...mapActions('authentication', ['loadImpfstelle']),
            ...mapActions('personen', ['loadPersonen']),
            ...mapActions('cards', ['loadCards']),
        },
    })
    export default class ImpfstelleDetail extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
            tabAllgemein: Vue & { $children: Validatable[] };
            tabAdresszeilen: Vue & { $children: Validatable[] };
            tabInfozeilen: Vue & { $children: Validatable[] };
            tabEimpfpass: Vue & { $children: Validatable[] };
            tabZahlungserinnerungen: Vue & { $children: Validatable[] };
            tabTermine: Vue & { $children: Validatable[] };
        };

        public impfstelle!: Impfstelle;
        public loadImpfstelle!: () => void;
        public loadPersonen!: (payload?: LoadPersonenPayload) => void;
        public loadCards!: () => void;
        public updateImpfstelleDetail!: (impfstelle: Impfstelle) => void;

        public tabIndex = 'tab-allgemein';
        public gv_ou_id: string | null = null;
        public showACardPin = false;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.tabIndex = 'tab-allgemein';
                this.showACardPin = false;

                this.loadImpfstelle();
                this.loadPersonen();
                this.loadCards();
            }
        }

        @Watch('loaders.impfstelle')
        public onChangeLoadersImpfstelle(loading: boolean): void {
            if (!loading) {
                this.gv_ou_id = this.impfstelle.gv_ou_id;
            }
        }

        public onClickSave(): void {
            this.$refs.form.validate();

            const tabs = {
                'tab-allgemein': this.$refs.tabAllgemein,
                'tab-adresszeilen': this.$refs.tabAdresszeilen,
                'tab-infozeilen': this.$refs.tabInfozeilen,
                'tab-eimpfpass': this.$refs.tabEimpfpass,
                'tab-zahlungserinnerungen': this.$refs.tabZahlungserinnerungen,
                'tab-termine': this.$refs.tabTermine,
            };

            for (const [tabIndex, ref] of Object.entries(tabs)) {
                if ((ref.$children as Validatable[]).some((child) => (child?.errorBucket?.length ?? 0) > 0)) {
                    this.tabIndex = tabIndex;
                    return;
                }
            }

            this.updateImpfstelleDetail(this.impfstelle);
        }
    }
